<template>
  <div class="base-swiper" @click="onClick">
    <div class="container">
      <slot name="header"/>
      <div class="swiper" ref="swiper">
        <div class="swiper-wrapper" ref="swiper-wrapper">
          <slot/>
        </div>
      </div>
      <slot name="footer"/>
      <div class="pagination" ref="pagination"/>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
import merge from 'lodash.merge'
export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    nextRoute: {
      type: String,
      required: false
    },
    tapToContinue: {
      type: Boolean,
      default: false
    },
    scrollingContent: {
      type: Boolean,
      default: false
    }
  },
  async mounted () {
    if (this.options.pagination) await this.options.pagination.el
    this.initSwiper()
    this.$emit('slide-change', this.swiper.realIndex)
    if (this.scrollingContent) this.enableScrollingContent()
    if (this.nextRoute) this.addTriggerNextRouteListeners()
    this.addSwipeListeners()
  },
  beforeDestroy () {
    // this.swiper.destroy()
  },
  data () {
    return {
      swiper: null,
      touchStartX: null,
      touchEndX: null,
      defaultOptions: () => ({
        pagination: { el: this.$refs['pagination'] }
      })
    }
  },
  computed: {
    onLastSlide () {
      return this.swiper.activeIndex === this.swiper.slides.length - 1
    }
  },
  methods: {
    initSwiper () {
      this.swiper = new Swiper(this.$refs['swiper'], merge(this.defaultOptions(), this.options))
    },
    addSwipeListeners () {
      this.swiper.on('slideChange', () => this.$emit('slide-change', this.swiper.realIndex))
      this.swiper.on('slideChangeTransitionEnd', () => this.$emit('slide-change-transition-end', this.swiper.realIndex))
      this.swiper.on('progress', progress => this.$emit('progress', progress))
    },
    enableScrollingContent () {
      let scrollY
      let touchStartX
      let touchStartY
      let touchCurrentY
      let touchCurrentX
      for (const slide of this.$refs['swiper-wrapper'].children) {
        if (slide.scrollHeight > slide.offsetHeight) slide.style.overflow = 'auto'
      }
      this.swiper.slides.on('touchstart', function (e) {
        scrollY = this.scrollTop
        touchStartX = e.targetTouches[0].pageX
        touchStartY = e.targetTouches[0].pageY
      }, true)
      this.swiper.slides.on('touchmove', function (e) {
        touchCurrentY = e.targetTouches[0].pageY
        touchCurrentX = e.targetTouches[0].pageX
        const slide = this
        const changeY = touchCurrentY - touchStartY
        const changeX = touchCurrentX - touchStartX
        const bottomY = slide.scrollHeight - slide.offsetHeight
        const direction = Math.abs(changeX) > Math.abs(changeY) ? 'horizontal' : 'vertical'
        const enableScroll =
          slide.scrollHeight > slide.offsetHeight && // slide has scrollable content
          direction === 'vertical' && // touch direction matches scrollable content direction
          ((changeY < 0 && scrollY === 0) || (changeY > 0 && scrollY >= bottomY) || (scrollY > 0 && scrollY <= bottomY))
        if (enableScroll) e.stopPropagation()
      }, true)
    },
    addTriggerNextRouteListeners () {
      this.swiper.on('touchStart', e => (this.touchStartX = e.type === 'touchstart' ? e.changedTouches[0].pageX : e.pageX))
      this.swiper.on('touchEnd', e => {
        const touchEnd = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX
        if (this.onLastSlide && this.touchStartX > touchEnd) this.$router.push(this.nextRoute)
      })
    },
    onClick () {
      if (this.tapToContinue && !this.nextRoute && !this.onLastSlide) this.updateSlide(this.swiper.activeIndex + 1)
      if (this.nextRoute) this.onLastSlide ? this.$router.push(this.nextRoute) : this.updateSlide(this.swiper.activeIndex + 1)
    },
    resetScroll () {
      this.swiper.slides[this.swiper.realIndex].scrollTop = 0
    },
    updateSlide (index) {
      this.swiper.slideTo(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-swiper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: visible;
}
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.swiper,
.swiper-wrapper {
  width: 100%;
}
.swiper-slide {
  width: 100%;
  height: auto;
}
.pagination {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  z-index: 1;
}
::v-deep .swiper-pagination-bullet {
  width: 25%;
  height: 1px;
  transition: opacity 0.2s ease-in-out;
  background-color: var(--color-white-1);
  opacity: 0.4;
  margin: 0 !important;
  border-radius: 0;
  &:not(:last-child) { margin-right: var(--spacing-6) !important }
  &.swiper-pagination-bullet-active { opacity: 1 }
}
</style>
